/* eslint-disable import/prefer-default-export */
/**
 * objtypeId에 해당하는 관리 구분 키를 반환한다.
 * @author Ju
 * @param  {[type]} objtypeId [description]
 * @return {[type]}           [description]
 */
export function getManagetypeKeyByObjtypeId(objtypeId) {
  let managetypeKey;
  switch (objtypeId) {
    case 'ORACLE':
      managetypeKey = 'OR';
      break;
    case 'MSSQL':
      managetypeKey = 'MS';
      break;
    case 'MYSQL':
      managetypeKey = 'MY';
      break;
    case 'TIBERO':
      managetypeKey = 'TB';
      break;
    case 'CUBRID':
      managetypeKey = 'CU';
      break;
    default:
      managetypeKey = null;
  }
  return managetypeKey;
}

/**
 * objDefineId에 해당하는 managetypeKey를 반환한다.
 * @author Ju
 * @param  {[type]} objtypeId [description]
 * @return {[type]}           [description]
 */
export function getManagetypeKeyByObjDefineId(objDefineId) {
  let managetypeKey;
  switch (objDefineId) {
    case 'NETDEVICE':
      managetypeKey = 'ND';
      break;
    case 'WIRELESS_DEVICE':
      managetypeKey = 'ND';
      break;
    case 'NETINTERFACE':
      managetypeKey = 'NI';
      break;
    case 'FMS_SENSOR':
      managetypeKey = 'FS';
      break;
    case 'FMS_DEVICE':
      managetypeKey = 'FD';
      break;
    default:
      managetypeKey = null;
  }
  return managetypeKey;
}

export function getManagetypeKey(managetypeId, objDefineId, objtypeId) {
  if (managetypeId === 'NMS') {
    return getManagetypeKeyByObjDefineId(objDefineId);
  } else if (managetypeId === 'DBMS') {
    return getManagetypeKeyByObjtypeId(objtypeId);
  } else if (managetypeId === 'VMS') {
    return objtypeId;
  }
  return null;
}

/**
 * 관리 구분이 여러 개의 관리 구분 키를 제공하는 지 여부를 반환한다.
 * @author Ju
 * @param  {[type]}  managetypeId [description]
 * @return {Boolean}              true: 관리 구분 키 여러 개 제공 / false: '_'만 제공
 */
export function isMultiKeyManagetype(managetypeId) {
  return managetypeId === 'NMS' || managetypeId === 'DBMS' || managetypeId === 'FMS' || managetypeId === 'VMS';
}



// WEBPACK FOOTER //
// ./src/utils/managetype-key.js